import React from "react";
import Spinner from "react-bootstrap/Spinner";

const Loader = () => {
  return (
    <div
      style={{
        height: "100vh",
        backgroundColor: "#000", // optional: background black
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        color: "#fff",
      }}
    >
      <Spinner animation="border" variant="light" />
    </div>
  );
};

export default Loader;
